import { render } from "./LocaleMenuView.vue?vue&type=template&id=7e1a93ec&scoped=true&ts=true"
import script from "./LocaleMenuView.vue?vue&type=script&lang=ts"
export * from "./LocaleMenuView.vue?vue&type=script&lang=ts"

import "./LocaleMenuView.vue?vue&type=style&index=0&id=7e1a93ec&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e1a93ec"]])

export default __exports__